import {
  Component,
  Input,
  Output,
  ElementRef,
  EventEmitter
} from "@angular/core";

import * as _ from "lodash";

import { FormService } from "../../form.service";
import { FormData } from "../../classes/data";
import { FormSchema } from "../../classes/schema";

import { FormSchemaData, FormSubmitEvent } from "../../form.interface";

/**
 * Renderiza um Ãºnico campo de formulÃ¡rio no HTML
 *
 * @example
 * <uex-input [schema]="schema" [(value)]="value"></uex-input>
 */
@Component({
  selector: "uex-input",
  templateUrl: "./input.component.html",
  host: {
    class: "uex-input"
  }
})
export class InputComponent {
  @Input("schema")
  private set __setSchema(schema: FormSchema | FormSchemaData) {
    schema && this._setSchema(schema);
  }

  @Input("value")
  set value(value: any) {
    this._value = value;
    this.valueChange.emit(this._value);
  }
  get value(): any {
    return this.schema.value;
  }

  get schema(): FormSchema {
    return this._schema;
  }

  @Output("onReady") onReady: EventEmitter<any> = new EventEmitter();
  @Output("schemaChange") schemaChange: EventEmitter<
    FormSchema
  > = new EventEmitter();
  @Output("valueChange") valueChange: EventEmitter<any> = new EventEmitter();

  /**
   * @ignore
   */
  constructor(
    private _formService: FormService,
    public elementRef: ElementRef
  ) {}

  /**
   * @ignore
   */
  public form: FormData;

  private _value: any;
  private _schema: FormSchema;

  /**
   * DistÃ¢ncia do elemento para o topo do elemento pai mais prÃ³ximo posicionado com relative
   */
  public get offsetTop(): number {
    return this.elementRef.nativeElement.offsetTop;
  }

  /**
   * Executa as validaÃ§Ãµes do campo
   */
  public validate(): FormSubmitEvent {
    this.form.validate();
    return {
      data: (<FormSchema>this.schema).value,
      valid: (<FormSchema>this.schema).valid,
      errors: (<FormSchema>this.schema).errors
    };
  }

  private _setSchema(schema: FormSchema | FormSchemaData) {
    if (schema instanceof FormSchema) {
      this.form = schema.form;
      this._schema = schema;
    } else {
      if (!schema.key) {
        schema.key = schema.type ? "input-" + schema.type : "input-text";
      }
      this.form = this._formService.create([<FormSchemaData>schema]);
      this._schema = this.form.schema[0];
    }

    if (!this._schema.value && this._value) {
      this._schema.value = this._value;
    }

    const on_change =
      this._schema.events && this._schema.events.onChange
        ? this._schema.events.onChange
        : null;
    const events = _.merge({}, this._schema.events, {
      onChange: event => {
        this.value = event.schema.value;
        if (_.isFunction(on_change)) {
          on_change(event);
        }
      }
    });

    this._schema.events = events;

    this.onReady.emit(this._schema);

    this.schemaChange.emit(this._schema);
  }
}
